export default __webpack_public_path__ + "b458cec9f58b28b2f5cc35cbd2ba1ffa.png";